"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = ThemeProvider;
exports.default = void 0;
var _cache = _interopRequireDefault(require("@emotion/cache"));
var _react = require("@emotion/react");
require("@ori-ui/license");
var _material = require("@ori-ui/mui-bundle/material");
var _system = require("@ori-ui/mui-bundle/system");
var _react2 = require("react");
var _theme = _interopRequireDefault(require("../theme"));
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable no-console -- needed for error propagation */

function ThemeProvider({
  children,
  theme = _theme.default,
  enableCacheProvider,
  cacheKey,
  cache,
  injectFirst = true
}) {
  const internalTheme = (0, _react2.useMemo)(() => {
    if (typeof theme === 'function') {
      return theme(_theme.default);
    }
    return theme;
  }, [theme]);
  const options = (0, _react2.useMemo)(() => cache ?? (0, _cache.default)({
    prepend: true,
    key: cacheKey ?? 'ori-ui'
  }), [cacheKey, cache]);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof cacheKey !== 'undefined' && enableCacheProvider !== true && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use cacheKey without enabling cache provider.`);
    }
    if (typeof cache !== 'undefined' && enableCacheProvider !== true && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use custom "cache" without enabling cacheProvider.`);
    }
    if (typeof cache !== 'undefined' && typeof cacheKey !== 'undefined' && enableCacheProvider === true && typeof window !== 'undefined') {
      console.error(`ORI-UI: The cacheKey you provided to ThemeProvider will be ignore since you provided custom "cache" too.`);
    }
  }
  if (!enableCacheProvider) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_system.StyledEngineProvider, {
      injectFirst: injectFirst,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ThemeProvider, {
        theme: internalTheme,
        children: children
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.CacheProvider, {
    value: options,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ThemeProvider, {
      theme: internalTheme,
      children: children
    })
  });
}
var _default = exports.default = /*#__PURE__*/(0, _react2.memo)(ThemeProvider);
